module.exports = __webpack_public_path__ + "media/images/homes/split_payment2x-11698a17cfef697fb8ccead3ab6df880.png";